import styled from 'styled-components'

import theme, {media} from '@/src/config/theme'

export const Pagination = styled.div`
  width: 100%;

  &.ant-pagination {
    justify-content: flex-end;
    flex: 1;

    .ant-pagination-item {
      background-color: transparent;
      color: ${theme.colors.textDark};
    }

    .ant-pagination-item-active {
      background-color: ${theme.colors.primary};
      color: ${theme.colors.text};
    }

    .ant-pagination-next,
    .ant-pagination-prev {
      color: ${theme.colors.white};

      svg {
        fill: ${theme.colors.white};
      }
    }
  }

  @media ${media.md} {
    &.ant-pagination {
      justify-content: flex-end;
    }
  }
`
